/**
 * Einkaufswelt: Block + Element "Aus dem Magazin"
 */
const { Component, Mixin } = Shopware;

Component.register('sw-cms-el-riccardo-magazine', {
    template: `
        <div class="sw-cms-el-riccardo-magazine" style="padding: 24px; border: 2px dashed #E30613; border-radius: 12px; text-align: center;">
            <strong style="font-size: 18px;">{{ element.config.title.value || 'Aus dem Magazin' }}</strong>
            <p style="margin: 8px 0 0; color: #52667a;">Zeigt die {{ element.config.limit.value }} neuesten Beiträge aus „Inhalte → Magazin“.</p>
        </div>
    `,
    mixins: [Mixin.getByName('cms-element')],
    created() {
        this.initElementConfig('riccardo-magazine');
    },
});

Component.register('sw-cms-el-config-riccardo-magazine', {
    template: `
        <div class="sw-cms-el-config-riccardo-magazine">
            <sw-text-field v-model:value="element.config.title.value" label="Überschrift" />
            <sw-number-field v-model:value="element.config.limit.value" number-type="int" :min="1" :max="12" label="Anzahl Beiträge" />
        </div>
    `,
    mixins: [Mixin.getByName('cms-element')],
    created() {
        this.initElementConfig('riccardo-magazine');
    },
});

Component.register('sw-cms-el-preview-riccardo-magazine', {
    template: `<div style="padding: 12px; font-weight: 700; color: #E30613; text-align: center;">Aus dem Magazin</div>`,
});

Component.register('sw-cms-block-riccardo-magazine', {
    template: `<div class="sw-cms-block-riccardo-magazine"><slot name="content"></slot></div>`,
});

Component.register('sw-cms-preview-riccardo-magazine', {
    template: `<div style="padding: 16px; text-align: center; color: #E30613; font-weight: 700;">Magazin-Beiträge</div>`,
});

Shopware.Service('cmsService').registerCmsElement({
    name: 'riccardo-magazine',
    label: 'Aus dem Magazin',
    component: 'sw-cms-el-riccardo-magazine',
    configComponent: 'sw-cms-el-config-riccardo-magazine',
    previewComponent: 'sw-cms-el-preview-riccardo-magazine',
    defaultConfig: {
        title: { source: 'static', value: 'Aus dem Magazin' },
        limit: { source: 'static', value: 3 },
    },
});

Shopware.Service('cmsService').registerCmsBlock({
    name: 'riccardo-magazine',
    label: 'Aus dem Magazin',
    category: 'text-image',
    component: 'sw-cms-block-riccardo-magazine',
    previewComponent: 'sw-cms-preview-riccardo-magazine',
    defaultConfig: { marginBottom: '20px', marginTop: '20px', sizingMode: 'boxed' },
    slots: { content: 'riccardo-magazine' },
});
